import React from 'react'
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from 'antd'
import logo from "./../../assets/Hermes.png"
import "./splashScreen.css"

function SplashScreen() {
  return (
    <div className='spashscreen-div'>
      <img src={logo} alt="logo" className='splashscreen-logo' />
      <br />
      <h1 className='splashscreen-title'>Chargement, veuillez patienter</h1>
      <Spin spinning={true} indicator={<LoadingOutlined className='splashscreen-loading' />} />
    </div>
  )
}

export default SplashScreen